import { DeleteButton, EditButton, List, useTable } from "@refinedev/antd";
import { Space, Table, Tag } from "antd";
import dayjs from "dayjs";
import { IconDisplay } from "../../components/IconDisplay";

/** House inventory before sold slots — the same order the reel uses. */
export function AdCreativesList() {
  const { tableProps } = useTable({
    resource: "ad-creative",
    syncWithLocation: true,
    queryOptions: { keepPreviousData: false, cacheTime: 0, staleTime: 0 },
    meta: { headers: { "Cache-Control": "no-cache", Pragma: "no-cache" } },
  });

  const columns = [
    {
      title: "Media",
      render: (_: any, r: any) => (
        <Space>
          <IconDisplay
            iconURL={r.posterURL || r.mediaURL}
            width={40}
            height={48}
            borderRadius="6px"
          />
          <Tag color={r.mediaType === "video" ? "purple" : "blue"}>{r.mediaType}</Tag>
        </Space>
      ),
    },
    {
      title: "Tier",
      dataIndex: "isHouse",
      render: (house: boolean) =>
        house ? <Tag color="green">From GymLive</Tag> : <Tag color="gold">Sponsored</Tag>,
    },
    { title: "Brand", dataIndex: "brand" },
    { title: "Title", dataIndex: "title" },
    {
      title: "CTA",
      render: (_: any, r: any) =>
        r.ctaType ? (
          <Tag color={r.ctaType === "external" ? "geekblue" : "cyan"}>
            {r.cta} → {r.ctaTarget}
          </Tag>
        ) : (
          <span>{r.cta}</span>
        ),
    },
    { title: "Priority", dataIndex: "priority" },
    {
      title: "Window",
      render: (_: any, r: any) => {
        if (!r.startsAt && !r.endsAt) return <span>—</span>;
        const from = r.startsAt ? dayjs(r.startsAt).format("DD MMM YY") : "now";
        const to = r.endsAt ? dayjs(r.endsAt).format("DD MMM YY") : "∞";
        return (
          <span>
            {from} → {to}
          </span>
        );
      },
    },
    {
      title: "Active",
      dataIndex: "isActive",
      render: (active: boolean) =>
        active ? <Tag color="green">Active</Tag> : <Tag color="red">Inactive</Tag>,
    },
    {
      title: "Actions",
      render: (_: any, record: any) => (
        <Space>
          <EditButton hideText size="small" recordItemId={record.id} />
          <DeleteButton hideText size="small" recordItemId={record.id} />
        </Space>
      ),
    },
  ];

  return (
    <div style={{ padding: "4px" }}>
      <List>
        <Table {...tableProps} columns={columns} rowKey="id" />
      </List>
    </div>
  );
}
